import { render, staticRenderFns } from "./RappiOnboarding.vue?vue&type=template&id=08104d74"
import script from "./RappiOnboarding.vue?vue&type=script&lang=js"
export * from "./RappiOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports